import { toast } from "sonner";

export function AppleIcon({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
    </svg>
  );
}

export function PlayIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true">
      <path fill="#EA4335" d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1z" />
      <path fill="#FBBC04" d="M47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0z" />
      <path fill="#4285F4" d="M472.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8z" />
      <path fill="#34A853" d="M104.6 499l280.8-161.2-60.1-60.1L104.6 499z" />
    </svg>
  );
}

const SIZES = {
  md: { pad: "px-5 py-3", icon: 26, playIcon: 22, top: "text-[10px]", bottom: "text-[15px]", gap: "gap-3" },
  lg: { pad: "px-7 py-4", icon: 34, playIcon: 28, top: "text-[11px]", bottom: "text-xl", gap: "gap-3.5" },
};

export function StoreButtons({ idPrefix, size = "md", center = false }) {
  const s = SIZES[size] || SIZES.md;
  const comingSoon = (store) =>
    toast.message(`${store} app — coming soon`, {
      description: "We're putting the finishing touches on it. Hit “Notify me at launch” below to be first in line.",
    });

  const badge = (testId, icon, top, bottom, store) => (
    <button
      key={testId}
      data-testid={testId}
      onClick={() => comingSoon(store)}
      className={`group flex items-center ${s.gap} ${s.pad} rounded-2xl border border-white/[0.14] bg-[#0B0C10] text-paper transition-all duration-300 hover:-translate-y-1 hover:border-acid/60 hover:shadow-[0_16px_40px_-12px_rgba(212,255,0,0.25)] active:scale-95`}
    >
      <span className="text-paper transition-transform duration-300 group-hover:scale-110">{icon}</span>
      <span className="text-left leading-tight">
        <span className={`block ${s.top} font-medium uppercase tracking-wider text-dim`}>{top}</span>
        <span className={`block ${s.bottom} font-bold`}>{bottom}</span>
      </span>
      <span className="ml-1 self-start rounded-full bg-olive px-2 py-0.5 text-[9px] font-bold uppercase tracking-widest text-acid">
        Soon
      </span>
    </button>
  );

  return (
    <div className={`flex flex-wrap gap-4 ${center ? "justify-center" : ""}`}>
      {badge(`${idPrefix}-app-store-button`, <AppleIcon size={s.icon} />, "Download on the", "App Store", "iOS")}
      {badge(`${idPrefix}-google-play-button`, <PlayIcon size={s.playIcon} />, "Get it on", "Google Play", "Android")}
    </div>
  );
}
